import systemSetStore from "./systemSet.js";

export default {
  systemSetStore: new systemSetStore()
};



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/stores/index.js